

import { Log, fanfanloI18n as i18n, isJson, logSetting } from '@fanfanlo';
import { AndroidListenerShell } from './android-listener-shell';
import _ from 'lodash';
import { webviewJsObjectName } from './is-in-android';
interface IAndroid{

}
export interface ICallAndroidReslt<T>{
    error?:Error|undefined
    javaResultString?:string
    javaResultData?:T
    errMsg?:string
}
export class WebViewJs {

    // static getErrNotInApp = ()=>{return new Error(i18n.t("WebViewJs.error.notInAndroid", {ns:"droid-android/android/content"}))}
    // static errNotInApp = new Error(i18n.t("WebViewJs.error.notInAndroid", {ns:"droid-android/android/content"}))
    // static errNoFun = new Error(i18n.t("WebViewJs.error.noMethod", {ns:"droid-android/android/content"}))
    static errNotInApp = new Error("not in app")
    static errNoFun = new Error("no method")

    // static getErrNotInApp = ()=>{return new Error("not in app")}
    static instance:WebViewJs;
    // 该属性可以在实现的对象里修改
    javascriptInterfaceName = webviewJsObjectName;
    log = new Log(false, this.constructor.name);
    androidListener = new AndroidListenerShell(this);
    constructor() {
        WebViewJs.instance = this;
    }
    init(){
        if(!this.isInApp)return false;
        // this.privateproxyConsoleLog();
        this.androidListener.init();
        return true;
    }
    get android():IAndroid{
        return (window as any)[this.javascriptInterfaceName];
    }
    get isInApp(){
        return !!this.android;
    }
    protected callInterface<T>(funName:string, ...args:any[]):ICallAndroidReslt<T>{
        // console.log('callInterface', `funName=${funName}`, `args=${args}`, `isInApp=${this.isInApp}`, `android=${this.android}`)
        if (!this.isInApp) return {error:WebViewJs.errNotInApp}
        if(!(this.android as any)[funName]) return {error:WebViewJs.errNoFun}
        try{
            const android = this.android
            const javaResultString = (android as any)[funName].apply(android, args);
            // console.log('callInterface result', `javaResultString=${javaResultString}`, `funName=${funName}`, `args=${args}`)
            let javaResultData:T|undefined = undefined;
            // if(_.isString(javaResultString)){
            if(isJson(javaResultString)){
                if(javaResultString && javaResultString.length > 1){
                    try{
                        javaResultData = JSON.parse(javaResultString)
                    }catch(e){
                        console.log('callInterface parse error data', `javaResultString=${javaResultString}`, `funName=${funName}`, `args=${args}`)
                        console.error('callInterface JSON.parse error', e)
                    }
                }
            }else if(javaResultString){
                javaResultData = javaResultString
            }
            return  {javaResultData, javaResultString}
        }catch(e){
            const err = e as Error
            console.log('callInterface call error', err?.message, err?.stack)
            return {error:e as Error, errMsg:err?.message}
        }
    }
    reload(){
        return this.callInterface("reload");
    }
    callJavaToJsDataString<T>(){
        return this.callInterface<T>("callJavaToJsDataString");
    }
    onDocumentReady(){
        return this.callInterface("onDocumentReady");
    }
    onJsCallEvent<T>(type:string, value:string){
        return this.callInterface<T>("onJsCallEvent", type, value);
    }
    dispatchData<T>(targetName:string, eventType:string, data:string){
        return this.callInterface<T>("dispatchData", targetName, eventType, data);
    }
    callExitFromJs<T>(){
        return this.callInterface<T>("callExitFromJs");
    }
    createWindow<T>(json:string){
        return this.callInterface<T>("createWindow", json);
    }
    readAllPackages<T>(){
        return this.callInterface<T>("readAllPackages");
    }
    openApp<T>(pn:string){
        console.log('openApp', pn)
        return this.callInterface<T>("openApp", pn);
    }
    openHelperTools<T>(){
        return this.callInterface<T>("openHelperTools");
    }
    openSelfByPackage<T>(){
        return this.callInterface<T>("openSelfByPackage");
    }
    callReadClipboard<T>(){
        return this.callInterface<T>("callReadClipboard");
    }
    toast<T>(text:string){
        return this.callInterface<T>("toast", text);
    }
    listen<T>(target:string, type:string, callbackEventType:string, once:boolean){
        return this.callInterface<T>("listen", target, type, callbackEventType, once);
    }
    removeListen<T>(target:string, index:number){
        return this.callInterface<T>("removeListen", target, index);
    }
    //获取webview的id
    webViewJsId(){
        return this.callInterface<number>("webViewJsId")
    }

    shellListen(target:string, type:string, callbackEventType:string, once:boolean, fun:(data:any)=>void){
        return this.androidListener.listen(target, type, callbackEventType, once, fun);
    }
    shellRemoveListen(target:string, index:any){
        return this.androidListener.removeListen(index);
    }
    printString(...args:any){
        let s = argsToString.apply(null, args)
        return this.callInterface("printString", s)
    }
    printError(...args:any){
        let s = argsToString.apply(null, args)
        return this.callInterface("printError", s)
    }
    private privateproxyConsoleLog(){
        logSetting.init(this.printString, this.printError, this.isInApp)
    }   
}
function argsToString(...args:any){

    let s = "";
    for (let i = 0; i < args.length; i++) {
        let t = args[i];
        let a = "";
        if(_.isError(t)){
            a = `err message is ${t.message}, stack is ${t.stack}`
        }
        else if(_.isObject(t)){
            try{
                a = JSON.stringify(t)
            }catch (e){
                // console.log("printString-try error", e)
            }
            finally {}
        }
        else if(_.isString(t)){a = t}
        else{
            a = `${t}`
        }
        if(s.length > 0){
            s = `${s} `
        }
        s += a;
    }
    return s;
}